// test687
(687 && 0);
